import * as Types from '../../gql.generated';

import gql from 'graphql-tag';
export type TransportFragmentFragment = (
  { __typename?: 'SenderRecipient' }
  & Pick<Types.SenderRecipient, '_id' | 'supplierNumber' | 'countryCode' | 'name' | 'place' | 'postCode' | 'street' | 'phone'>
);
export const TransportFragmentFragmentDoc = gql`
    fragment TransportFragment on SenderRecipient {
  _id
  supplierNumber
  countryCode
  name
  place
  postCode
  street
  phone
}
    `;